module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$route.fullPath != '/home' ? 'footer' : 'footer-bg'
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container w"
  }, [_c('div', {
    staticClass: "footer-info"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2022 医小智（日照）工业互联网有限公司 版权所有")]), _vm._v(" "), _c('div', {
    staticClass: "icp-row"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=37110202371204",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("鲁公网安备37110202371204")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("鲁ICP备2022031907号-1")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033469"
    }
  }, [_vm._v("鲁B2-20240306")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c512bb7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/MFooter.vue
// module id = 675
// module chunks = 0